<p-toast position="bottom-center"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-title">
  <div class="page-title-text">
    <h3>User Management</h3>
  </div>
  <div class="page-title-actions">
    <p-button 
      label="Create User"
      icon="pi pi-plus"
      severity="success"
      (onClick)="showCreateUserModal()"
      size="small">
    </p-button>
  </div>
</div>

<p-card>
  <app-besharp-table
    [tableItems]="datasource"
    [totalRecords]="datasourceLength"
    [lazyMode]="true"
    [loading]="loading"
    [debounceSearchTime]="300"
    [idColumnDef]="'id'"
    [tableDefinitions]="tableDefinition"
    [actionDefinitions]="actionDefinition"
    [globalFilterFields]="globalFilterFields"
    [actionTitle]="'Actions'"
    [tableSize]="eBesharpTableSize.Small"
    [defaultActive]="'id'"
    [defaultDirection]="-1"
    [paginator]="true"
    [pageRows]="pageRows"
    [pageRowsOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    [showSearchInput]="true"
    [showClearFiltersButton]="true"
    [showStripes]="true"
    [showGridLines]="false"
    [rowOverEffect]="true"
    (onPageChange)="onPageChange($event)"
    (onSortChange)="sortChangedEvent($event)"
    (onClearFilters)="clearFilters()"
    (onColumnFilter)="onColumnFilter($event)"
    (onGlobalSearch)="onGlobalSearch($event)"
  />
</p-card>

<p-dialog
  [(visible)]="displayCreateUserDialog"
  [header]="'Create New User'"
  [modal]="true"
  [style]="{ width: '70vw' }"
  [breakpoints]="{ '960px': '85vw', '640px': '95vw' }"
  (onHide)="resetCreateUserForm()">
  <div class="create-user-form">
    <div class="form-row">
      <div class="form-group">
        <label for="email">Email (Username) *</label>
        <input
          pInputText
          id="email"
          [(ngModel)]="createUserForm.email"
          type="email"
          placeholder="user@example.com"
          class="form-control" />
      </div>

      <div class="form-group">
        <label for="userType">User Type *</label>
        <p-select
          id="userType"
          [(ngModel)]="createUserForm.userType"
          [options]="userTypes"
          optionLabel="name"
          optionValue="name"
          placeholder="Select a user type"
          [loading]="loadingUserTypes">
          <ng-template #value let-value>
            <div *ngIf="value">
              {{ getUserTypeNameById(value) }}
            </div>
            <div *ngIf="!value" class="placeholder-text">
              Select a user type
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group" [class.has-error]="isPasswordTooShort || showPasswordError">
        <label for="password">Password *</label>
        <p-password
          id="password"
          [(ngModel)]="createUserForm.password"
          [toggleMask]="true"
          placeholder="Enter password (min 8 characters)"
          [feedback]="false"
          [ngClass]="{'error-input': isPasswordTooShort || showPasswordError}">
        </p-password>
        <small *ngIf="isPasswordTooShort" class="error-message">
          <i class="pi pi-exclamation-circle"></i> Password must be at least 8 characters
        </small>
      </div>

      <div class="form-group" [class.has-error]="showPasswordError">
        <label for="confirmPassword">Confirm Password *</label>
        <p-password
          id="confirmPassword"
          [(ngModel)]="createUserForm.confirmPassword"
          [toggleMask]="true"
          placeholder="Re-enter password"
          [feedback]="false"
          [ngClass]="{'error-input': showPasswordError}">
        </p-password>
        <small *ngIf="showPasswordError" class="error-message">
          <i class="pi pi-exclamation-circle"></i> Passwords do not match
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="name">Name *</label>
        <input
          pInputText
          id="name"
          [(ngModel)]="createUserForm.name"
          type="text"
          placeholder="First Name"
          class="form-control" />
      </div>

      <div class="form-group">
        <label for="surname">Surname *</label>
        <input
          pInputText
          id="surname"
          [(ngModel)]="createUserForm.surname"
          type="text"
          placeholder="Last Name"
          class="form-control" />
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="country">Country *</label>
        <p-select
          id="country"
          appendTo="body"
          [(ngModel)]="createUserForm.country"
          [options]="countries"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a country"
          [filter]="true"
          filterPlaceholder="Search country..."
          (onChange)="onCountryChange($event.value)">
        </p-select>
      </div>

      <div class="form-group" [class.has-error]="showPhoneNumberError">
        <label for="phoneNumber">Phone Number *</label>
        <input
          pInputText
          id="phoneNumber"
          [(ngModel)]="createUserForm.phoneNumber"
          type="tel"
          placeholder="Format: +393331234567"
          class="form-control"
          (input)="onPhoneNumberInput()"
          [ngClass]="{'error-input': showPhoneNumberError}" />
        <small *ngIf="showPhoneNumberError" class="error-message">
          <i class="pi pi-exclamation-circle"></i> Phone number must be in this format: +393331234567
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group form-group-full">
        <label for="address">Address *</label>
        <input
          pInputText
          id="address"
          [(ngModel)]="createUserForm.address"
          type="text"
          placeholder="Street Address"
          class="form-control" />
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      icon="pi pi-times"
      (onClick)="displayCreateUserDialog = false"
      severity="secondary">
    </p-button>
    <p-button
      label="Create"
      icon="pi pi-plus"
      (onClick)="createUser()"
      [loading]="creatingUser"
      [disabled]="!isFormValid"
      severity="success">
    </p-button>
  </ng-template>
</p-dialog>
